/**
 * Service helpers for Section Risk Score tab
 */

import { CONTROL_EFFICACY_MAX_VALUE, CONTROL_EFFICACY_MIN_VALUE } from "./controlEfficacyService";

export const SECTION_RISK_COLOR_PALETTE = {
    blue: "#0000FF",
    green: "#008000",
    yellow: "#FEF800",
    orange: "#F66400",
    red: "#DA0000",
};

const SECTION_RISK_SCORE_RANGES = [
    { maxExclusive: 6.1, colorKey: "red" },
    { maxExclusive: 20.1, colorKey: "orange" },
    { maxExclusive: 40.1, colorKey: "yellow" },
    { maxExclusive: 79.1, colorKey: "green" },
    { maxExclusive: 101, colorKey: "blue" },
];

export const calculateSectionRiskScore = (controlEfficacy, inherentRiskScore) => {
    const control = parseInt(controlEfficacy, 10);
    const inherent = parseInt(inherentRiskScore, 10);

    if (
        Number.isNaN(control) ||
        control < CONTROL_EFFICACY_MIN_VALUE ||
        control > CONTROL_EFFICACY_MAX_VALUE
    ) {
        return "";
    }

    const hasValidInherent = !Number.isNaN(inherent) && inherent >= 1 && inherent <= 10;
    const score = hasValidInherent
        ? control * inherent
        : control * 10;

    return score.toString();
};

export const getSectionRiskColorKey = (score, hasValidInherent = true) => {
    const numeric = Number(score);
    if (!Number.isFinite(numeric) || numeric <= 0) return null;

    const normalizedScore = Math.min(100, numeric);

    if (!hasValidInherent) {
        if (normalizedScore <= 20) return "red";
        if (normalizedScore <= 40) return "orange";
        if (normalizedScore <= 60) return "yellow";
        if (normalizedScore <= 80) return "green";
        return "blue";
    }

    const matchedRange = SECTION_RISK_SCORE_RANGES.find(
        (range) => normalizedScore < range.maxExclusive
    );

    return matchedRange?.colorKey ?? null;
};

export const getSectionRiskHexColor = (score, hasValidInherent = true) => {
    const colorKey = getSectionRiskColorKey(score, hasValidInherent);
    return colorKey ? SECTION_RISK_COLOR_PALETTE[colorKey] : null;
};

export const getSectionRiskColor = (score, hasValidInherent = true) => {
    const hexColor = getSectionRiskHexColor(score, hasValidInherent);
    return hexColor ? `bg-[${hexColor}]` : "bg-[#DA0000]";
};
